import React from 'react';
import './Lists.scss';
import '../../resources/StandardStyles.scss';
import Footer from '../../components/Footer/Footer.jsx';
import Header from '../../components/Header/Header';
import NativeSelect from '@material-ui/core/NativeSelect';
import FormControl from '@material-ui/core/FormControl';
import listJson from './list.json';

class Personal extends React.Component{
    constructor(props){
        super(props)
        this.state={
            list:listJson
        }
    }

    render(){
        return(
            <div className='standard list'>
            <Header/>
            <div className='standard__first-section'>
                <h2 className='standard__general-title'>Personal</h2>
                {/* <h4 className='standard__general-description'>Legea asupra instrucţiunii" din noiembrie 1864 prevedea la articolul 184: "în toate oraşele unde sunt licee de băieţi, se vor stabili şcoli secundare de fete compuse din cinci clase".</h4> */}
            </div>
            <div className='list__container'>
                <h3 className='standard__section-title'>Membri Personal</h3>
                {this.state.list.map(item=>(
                    <div className='list__individual' key={item.key}>
                        <h3 className='list__person'>{item.name}</h3>
                        <h3 className='list__function'>{item.function}</h3>
                    </div>
                ))}
            </div>
            <Footer/>
        </div>
        )
    }
}
export default Personal;